import { Client } from '@/core/entity';
import { IClientGateway, ClientInput, UpdaterFunc, PresenterFunc } from '@/core/interface';
import { CreateClient, UpdateClient } from '@/core/usecase';

export class ClientController {
  constructor(
    private readonly clientGw: IClientGateway,
  ) { }

  public create(
    input: ClientInput,
    presenter: PresenterFunc<Client | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new CreateClient(this.clientGw);

    useCase.execute(input, presenter, updater);
  }

  public update(
    id: string,
    input: ClientInput,
    presenter: PresenterFunc<Client | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new UpdateClient(this.clientGw);

    useCase.execute(id, input, presenter, updater);
  }
}
